export const ACTIONS_RAILS_LIVE_STATION_INIT = 'ACTIONS_RAILS_PNR_STATUS_INIT';
export const ACTIONS_RAILS_LIVE_STATION_SHOW_DETAILS = 'ACTIONS_RAILS_LIVE_STATION_SHOW_DETAILS';
export const ACTIONS_RAILS_LIVE_STATION_SET_NO_NETWORK = 'ACTIONS_RAILS_LIVE_STATION_SET_NO_NETWORK';
export const ACTIONS_RAILS_LIVE_STATION_INFO_SHOW_LOADER = 'ACTIONS_RAILS_LIVE_STATION_INFO_SHOW_LOADER';
export const ACTIONS_RAILS_INFO_SHOW_ERROR = 'ACTIONS_RAILS_INFO_SHOW_ERROR';
export const ACTION_RIS_ON_ORIGIN_SELECTED = 'ACTION_RIS_ON_ORIGIN_SELECTED';
export const ACTION_ON_BACK_PRESS = 'ACTION_ON_BACK_PRESS';
export const ACTION_OPEN_TRAIN_PICKER = 'ACTION_OPEN_TRAIN_PICKER';
export const ACTIONS_RAILS_LIVE_STATION_INITIAL_STATE = 'ACTIONS_RAILS_LIVE_STATION_INITIAL_STATE';

export const INPUT_CITY_SELECTED = {
    source: 'SOURCE',
    destination: 'DESTINATION',
    defaults: 'DEFAULTS'
};
